import { Get } from "./api";

export const getRegions = async () => {
  const result = await Get('/api/regions');

  return result.data;
};

export const getRegionStats = async () => {
  const result = await Get('/api/regions/stats');

  return result.data;
};

export const getRegionByName = async (name) => {
  const result = await Get(`/api/region/${name}`);

  return result.data;
};
